import { resolve } from 'promise';
import { shouldEnableSticky } from '../helpers/born.utils';
import GalleryZoom from '../modules/module.zoom';
import { pdpOfferTimer } from '../offertimer';
var bornModules = require('../helpers/born.modules').default;
var ajax =  require('../ajax');
var util = require('../util');
var checkinstore = require('./checkinstore');
var pageNumber = 1;
var progress = require('../progress');
var $main = $('#main');
var lazyPictureLoad = require('../lazypictureload');

export function init() {
	var pID = document.querySelector('#pid') ? document.querySelector('#pid').value : 'product-set',
		thumbContainer = document.querySelector('.pdp__gallery__sm'),
		thumbCount;
		checkinstore.initstore();
	if (thumbContainer) {
		$('.pdp__gallery__lg').on('galleryZoomStart', function() {
			lazyLoadPDPVideo('.zoom-row');
			let isFullScreen = false;
			$('.zoom-row video').on('fullscreenchange mozfullscreenchange webkitfullscreenchange', () => {
				isFullScreen && $('.zoom__gallery').slick('refresh');
				isFullScreen = !isFullScreen;
			})
			$(this).off('galleryZoomStart');
		});
		var thumbCount = thumbContainer.getAttribute('data-thumbcount'),
			thumbCountCap = {
				tablet: parseInt(thumbCount > 4 ? 4 : thumbCount),
				desktop: parseInt(thumbCount > 8 ? 8 : thumbCount)
			},
			zoom = new GalleryZoom({
				modalID: pID,
				gallery: '.pdp__gallery__lg',
				items: '.pdp__gallery__media',
				useTrigger: true,
				sliderSyncing: true,
				thumbsSlick: {
					slidesToShow: thumbCountCap.desktop,
					slidesToScroll: thumbCountCap.desktop,
					vertical: true,
					verticalSwiping: true,
					responsive: [{
						breakpoint: 1025,
						settings: {
							slidesToShow: thumbCountCap.tablet,
							slidesToScroll: thumbCountCap.tablet,
						}
					}]
				},
				gallerySlick: {
					fade: true,
					waitForAnimate: false,
					adaptiveHeight: true,
					responsive: [{
						breakpoint: 767,
						settings: {
							arrows: true,
							dots: true,
							swipe: true
						}
					}]
				}
			});
	}
	updateRatingPercentageWidth();
	handleReviewSort();
	handleMoreReviews();
	handleShowLessReviews();
	scrollToReview();
	reviewSortAction();
	bookstoreappointment();
	handlePDPGAEvents();
	$('#add-to-cart').attr('disabled', false);
	
	// PHNX-1038 Changes
	window.addEventListener('load', function () {
		var countrySelectorDropDown = $('#countrySelectorList');
		if(countrySelectorDropDown.length > 0 && countrySelectorDropDown.find('[selected="selected"]').length > 0){
			countrySelectorDropDown.val($('#countrySelectorList [selected="selected"]').val()).selectric('refresh');
		}
	});
	$('.description-spec-toggler').off('click.hltDescToggle').on('click.hltDescToggle', () => {
		$('.pdp__info.secondary__info').toggleClass('active');
		const toggleElement = '.pdp__info.secondary__info .pdp__info__wrapper .pdp__info__section';
		$(`${toggleElement}.toggle--active`).length === 0 && $(`${toggleElement} .toggle__link`).first().click();
		$('html, body').toggleClass('no-scroll');
	})
	lazyLoadPDPVideo();
	dockImgAtTop();

	thumbNextBtnPlacement();
	slickOnResizeHandler();
	
	$(document).ready(function (){
		hideEmptySection();
	})
	pdpOfferTimer();
	setTimeout(() => {
		shouldKeepSwatchesOpen();
	}, 500);
	quantityButtonCheck();
	videoPlayClickListener();
	lazyPictureLoad.init();
	showHidemobileGalleryPopup();
	addEllipsisToBreadcrumbMob();
}

function addEllipsisToBreadcrumbMob() {
	let timer;

	$(window).on('load resize modal-open', ()=>{
		debounce(() => {
			if(window.innerWidth > 767) return;
			const $breadcrumbs = $('#breadcrumbs, .coming-soon__dialog #breadcrumbs, .back-in-stock__dialog #breadcrumbs');
			const haveOverflow = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
			haveOverflow ? $breadcrumbs.addClass('show-ellipsis') :  $breadcrumbs.removeClass('show-ellipsis');
		}, 200, timer);
	});
}

// To set the top offset of next button in thumbnails according to height of the thumbnail container
function thumbNextBtnPlacement() {
	const parseMutations = () => {
		$('#thumbnails .slick-next').css('top', `${$('#thumbnails .slick-list').height() - 32}px`);
	}
	var observer = new MutationObserver(parseMutations);
	const doObserve = () => {
		parseMutations();
		observer.observe($('#thumbnails .slick-list').get(0), {
			attributeFilter: ["style"],
		});
	}
	if ($('#thumbnails .slick-list').length > 0) {
		doObserve();
	} else {
		let interval = setInterval(() => {
			if ($('#thumbnails .slick-list').length > 0) {
				doObserve();
				clearInterval(interval);
			}
		}, 200);
	}
}

// refresh slick on resize and adjust next button placement
function slickOnResizeHandler() {
	let rTime, timeout = false, delta = 200;
	$(window).on('resize', () => {
		if (window.innerWidth < 768) return;
		rTime = new Date();
		if (!timeout) {
			timeout = true;
			setTimeout(resizeEnd, delta);
		}
	});

	const resizeEnd = () => {
		if (new Date() - rTime < delta) {
			setTimeout(resizeEnd, delta);
		} else {
			timeout = false;
			$('#thumbnails').slick('refresh');
			thumbNextBtnPlacement();
		}
	}
}

function bookstoreappointment(){
	if($(".appointment-cta").length > 0){
		$(document).on('click','.appointment-cta',function(){
			e.preventDefault();
			var brandNameEl = $('input[name="produc-brand-name"]');
			var url = $(this).attr('href');
			if(brandNameEl.length <= 0) {
				window.location = url;
				return;
			}
			var brandName = brandNameEl.val();
			if(brandName) {
				brandName = brandName.trim();
				url += url.indexOf("?") === -1 ? "?" : "&";
				window.location = url+"name="+encodeURIComponent(brandName);
			} else {
				window.location = url;
			}
		});
	}
}

function reviewSortAction(){
	var $toggledElements = $('.review__sorts,.review-sort-by-toggle');
    const propagationHandler=(e)=> {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        if (!$toggledElements.hasClass('toggle--active')) {
            $('#main').off('click','.review-sort-by-toggle',(e) => e.stopPropagation());
            $(window).off('click', propagationHandler);
            $('body').removeClass('cancel-scroll');
        }
    }
	$('.review__sorts').on('click', function (e) {
		e.stopPropagation();
        var width = $(window).width();
		if (width <= 767) {
			$('body').addClass('cancel-scroll');
			if ($(e.currentTarget).hasClass('toggle--active')) {
				if(typeof zE !== 'undefined' && !!zE) {
					zE(function() {
					   zE.hide();
					});
				}
			}
		}
		$(window).on('click', propagationHandler);
    });
}
function hideSortOption(){
	var $toggleEle  = $(".review-sort-by-toggle,.review-sort-by-toggle .toggle__content,.review-sort-by-toggle .toggle__link");
	if($(".review-sort-by-toggle").hasClass('toggle--active')){
		$toggleEle.removeClass('toggle--active');
		$('body').removeClass('cancel-scroll');
	}
}
function handleMoreReviews() {
	$('#more-reviews').on('click',function() {
		progress.show($('.reviews-listing'));
		var url = $('.review__rating--sortby a.review-sort-selected').attr('href')
		var existingReviewsCount = $('.review-entry-wrapper').length;
		url = util.appendParamsToUrl(url, {
            'existingReviewsCount': existingReviewsCount
        });
		$.ajax({
			type : 'GET',
			url : url,
			success: function (response) {
				$('.reviews-listing').append(response);
				updateRatingPercentageWidth();
				hideOrShowButton();
				progress.hide();
			}
		});
	});

	//avoid review sort menu closing, if clicked inside the menu
	$main.on('click','.review-sort-by-toggle',(e) => {
        e.stopPropagation();
    });
    //Hide the sort menu if visible
    $(window).click(function(e) {
        e.stopPropagation();
        var $toggledElements = $('.review-sort-by-toggle');
        if ($toggledElements.hasClass('toggle--active')) {
            $toggledElements.removeClass('toggle--active');
        }
    });
}

function handleShowLessReviews() {
	$('#show-less-reviews').on('click',function() {
		progress.show($('.reviews-listing'));
		var url = $('.review__rating--sortby a.review-sort-selected').attr('href');
		$.ajax({
			type : 'GET',
			url : url,
			success: function (response) {
				$('.review-details-wrapper').remove();
				$('.reviews-listing').append(response);
				updateRatingPercentageWidth();
				hideOrShowButton();
				$('html, body').animate({
					scrollTop: $(".pdp-reviews-wrapper").offset().top-80
				}, 2000);
				progress.hide();
			}
		});
	});
}


function handleReviewSort() {
	$('.review__rating--sortby a').on('click', function (e) {
		e.preventDefault();
		progress.show($('.reviews-listing'));
		$('.review__rating--sortby a.review-sort-selected').removeClass('icon--tick review-sort-selected');
		$(this).addClass('icon--tick review-sort-selected');
		ajax.load({
			url: $(this).attr('href'),
			target:$('.reviews-listing'),
			callback: function (data) {
				updateRatingPercentageWidth();
				hideOrShowButton();
				hideSortOption();
				progress.hide();
			}
		});
	});
}

function updateRatingPercentageWidth() {
	$('.ratingstart').each(function() {
		var ratingPercentage = getRatingPercentage($(this).data('score'));
		$(this).find('.stars-inner').width(ratingPercentage);
	})
}

function getRatingPercentage(rating) {
    var ratingTotal = 5;
    var ratingPercentage = (rating / ratingTotal) * 100;
    ratingPercentage = ratingPercentage + '%';
    return ratingPercentage;
  }

function hideOrShowButton() {
	var existingReviewsCount = $('.review-entry-wrapper').length;
	var totalReviewsCount = $('.reviews-listing').data('totalreview');
	// Reviews per page 5
	if (totalReviewsCount > 5) {
		if (existingReviewsCount < totalReviewsCount) {
			$('#more-reviews').show();
			$('#show-less-reviews').hide();
		} else if (existingReviewsCount == totalReviewsCount) {
			$('#more-reviews').hide();
			$('#show-less-reviews').show();
		}
	}
}

function scrollToReview(){
	$("#product-avg-rating").on('click',function() {
		setTimeout(()=>{
			$([document.documentElement, document.body]).animate({
				scrollTop: ($(".pdp-reviews-wrapper").offset().top-100)
			}, 1000);
		},500);
	});
}

function lazyLoadPDPVideo(container = '.pdp__gallery') {
	let video = $(`${container} video`);
	const videoElem = video.get(0);
	let sources = video.find('source');
	const hasShowSimilar = $(`${container} .pdp__gallery__show-similar`).length > 0;

	video.off('click.controls').on('click.controls', (e) => {
		if (videoElem.paused) {
			videoElem.play();
			return;
		}
		videoElem.pause();
	});

	const setSources = (resolve, _sources = sources) => {
		_sources.each(function (index) {
			$(this).attr('src', $(this).data('vdosrc'));
			if (index + 1 == _sources.length) {
				video.addClass('src-loaded');
				resolve();
			}
		});
	}

	const loadVideo = (_videoElem = videoElem, shouldPlay = true) => {
		try {
			_videoElem.pause();
			_videoElem.load();
			shouldPlay && _videoElem.addEventListener('loadeddata', function() {
				_videoElem.play();
			}, false);
		} catch (err) {}
	}

	// lazy load on slide change
	function callback(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (!mutation.type === 'attributes' || !mutation.attributeName === 'class') return;

			if (mutation.target.classList.contains('slick-active')) {
				hasShowSimilar && $('.pdp__gallery__show-similar').hide();

				if (!video.hasClass('src-loaded')) {
					new Promise((resolve, reject) => {
						setSources(resolve);
					}).then(() => {
						loadVideo();
					});
				}
			} else {
				hasShowSimilar && $('.pdp__gallery__show-similar').show();
			}
		});
	  }
	const observer = new MutationObserver(callback);
	video.length && observer.observe(video.parent(`${container} .video--playwrap`).get(0), { attributes: true });
}

function isOverflown(element) {
	return element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
}

function debounce(callback, delay, timer) {
	clearTimeout(timer);
	timer = setTimeout(callback, delay);
}

function dockImgAtTop() {
	// Remove the existing scroll listener if module is re initialized (In case of variant selection for product with variants)
	$(window).off('scroll.pdpScrollEvent');

	const $imageContainer = $('.product-image-container'),
		$imageRow = $('#pdp-img-row'),
		$breadcrumbs = $('#breadcrumbs, .coming-soon__dialog #breadcrumbs, .back-in-stock__dialog #breadcrumbs'),
		$pdpRightSection = $('.pdp__right-section');
	let isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0)),
		headerHeight = Math.round($('.header__main').height()),
		calcedHeaderHeight = shouldEnableSticky() ? headerHeight : 0;

	let rightSectHeight = $pdpRightSection.height();

	const toggleOverflow = () => {
		if ($breadcrumbs.length === 0 || window.innerWidth < 768) return;
		if ($(window).scrollTop() >= 60) {
			$breadcrumbs.addClass('show-ellipsis');
		} else {
			$breadcrumbs.removeClass('show-ellipsis');
		}
	};

	if (isBreadCrumbOverflown) {
		$(window).on('scroll.pdpScrollEvent', toggleOverflow);
		toggleOverflow();
	}

	const dockDecision = (height) => {
		const windowHeight = window.innerHeight;
		$imageRow.css( 'top', '');
		if (height < (windowHeight - calcedHeaderHeight))
			$imageRow.css('top', `${calcedHeaderHeight + 5}px`);
		else {
			const topVal = Math.round(
				calcedHeaderHeight -
				Math.abs(height - (windowHeight - calcedHeaderHeight))
			) - 82 + 'px';
			$imageRow.css('top', topVal);
		}
	};

	let timer;
	$(window).on('resize', () => {
		if (window.innerWidth > 767) {
			headerHeight = Math.round($('.header__main').height());
			calcedHeaderHeight = shouldEnableSticky() ? headerHeight : 0;
			debounce(()=>{
				$(window).off('scroll.pdpScrollEvent');
				$breadcrumbs.removeClass('show-ellipsis');
				isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
				if (isBreadCrumbOverflown) {
					$(window).on('scroll.pdpScrollEvent', toggleOverflow);
					toggleOverflow();
				}
			}, 200, timer);
			dockDecision($imageContainer.height());
		} else
			$imageRow.css( 'top', '');
	});

	new ResizeObserver((entries) => {
		for (const entry of entries) {
			const newHeight = entry.contentRect.height;
			dockDecision(newHeight);
		}
	}).observe($imageContainer.get(0));

	//to maintain scroll position
	new ResizeObserver((entries) => {
		for (const entry of entries) {
			let newHeight = entry.contentRect.height;
			if (newHeight < rightSectHeight && window.lastScrollPos) {
				const curScrollPos = $(window).scrollTop();
				window.lastScrollPos > curScrollPos && $(window).scrollTop(window.lastScrollPos - (rightSectHeight - newHeight))
			}
			window.lastScrollPos = null;
			rightSectHeight = newHeight;
		}
	}).observe($pdpRightSection.get(0));

	window.innerWidth > 767 && dockDecision($imageContainer.height());
}

function hideEmptySection()
{
	var sections = $('.pdp__info__section .pdp__info__content');
	let setFirstContent = false;
	sections.each(function(i, e){
		var details = $(e).html();
		details = details.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, "");
		var el = $(e).closest('.pdp__info__section');
		if(!$.trim(details)) {
			if(el.length >0) {
				el.addClass('hidden');
			}
		} else if(!setFirstContent) {
			el.addClass('first-content');
			setFirstContent= true;
		}
	});
}

function handlePDPGAEvents(){
	var user=dataLayer.find(o => o.user != null).user;
	var product = dataLayer.find(o => o.product != null).product;
	$('.sharing__trigger').on('click',function() {
		dataLayer.push({
			"event": 'custom_event',
			"eventCategory": 'PDP',
			"eventAction": 'pdp_share_click',
			"eventLabel": 'pdp share click',
			"productName": product.name,
			"country": window.GlobalAttributes.COUNTRY,
			"language": window.GlobalAttributes.LANGUAGE,
			"screenName" : 'PDP',
			"userType": user.user_id!='' ? 'logged-in' : 'logged-out',
			"userId": user.user_id!=''? user.user_id : ''
		});
	})
	
	$('.sharing__item').on('click',function() {
		dataLayer.push({
			"event": 'custom_event',
			"eventCategory": 'PDP',
			"eventAction": 'pdp_social_share',
			"eventLabel": $(this).data('share'),
			"productName": product.name,
			"country": window.GlobalAttributes.COUNTRY,
			"language": window.GlobalAttributes.LANGUAGE,
			"screenName" : 'PDP',
			"userType": user.user_id!='' ? 'logged-in' : 'logged-out',
			"userId": user.user_id!=''? user.user_id : ''
		});
	})
	$('body').on('click','.js-size-guide-btn',function() {
		dataLayer.push({
			"event": 'custom_event',
			"eventCategory": 'PDP',
			"eventAction": 'pdp_size_guide',
			"eventLabel": 'pdp size guide click',
			"productName": product.name,
			"country": window.GlobalAttributes.COUNTRY,
			"language": window.GlobalAttributes.LANGUAGE,
			"screenName" : 'PDP',
			"userType": user.user_id!='' ? 'logged-in' : 'logged-out',
			"userId": user.user_id!=''? user.user_id : ''
		});
	})

	$('body').on('click','.store-dirlink',function() {
		var storeName = $(this).parent().find('.store-name').text();
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'PDP',
			'eventAction': 'in_store_availability_get_direction',
			'eventLabel': 'check in store availability get direction - ' + storeName, //Store Name i..e Dubai Hills Mall
			"productName": product.name,
			"country": window.GlobalAttributes.COUNTRY,
			"language": window.GlobalAttributes.LANGUAGE,
			"screenName" : 'PDP',
			"userType": user.user_id!='' ? 'logged-in' : 'logged-out',
			"userId": user.user_id!=''? user.user_id : ''
		});
	})
	
}


// function to keep swatches open when a variant from the hidden swatches are accessed directly
function shouldKeepSwatchesOpen() {
	let $swatchContainer = $('#swatch-variation');
	if ($swatchContainer.length == 0) return;
	let index = -1;
	index = $swatchContainer.find('.swatches__item').index($('.swatches__item.selected'));
	const containerWidth = $swatchContainer.innerWidth(),
		elementWidth = $('.swatches__item').innerWidth() + parseInt($('.swatches__item').css('margin-right'));
	const visibleItems = parseInt(containerWidth / elementWidth) * 2;
	if ((index + 1) > visibleItems) {
		$('#show-more-link:not(.toggle--active)').trigger('click');
	}
}
function quantityButtonCheck() {
	$('input.qty-input__ctrl').on('change', (event) => {
		let maxValue;
		const maxQty = $(event.target).data('max-qty');
		if (maxQty > 0) {
			maxValue = maxQty;
		} else {
			maxValue = $(event.target).data('available');
		}
		const currVal = event.target.value;
		if (currVal < maxValue) {
			$('button.qty-input__ctrl.plus').removeAttr('disabled');
		} else {
			$('button.qty-input__ctrl.plus').attr('disabled', 'true');
		}
		if (currVal <= maxValue) {
			$('button.add-to-cart').removeAttr('disabled');
		} else {
			$('button.add-to-cart').attr('disabled', 'true');
		}
	});
}
function videoPlayClickListener() {
	$('.pdp__product-gallery--video-tile.video-tile').on('click.pointerEventsListener', function () {
		$(this).find('video').removeClass('no-pointer-events');
		$(this).off('click.pointerEventsListener');
	});
	$('.pdp__product-gallery--popup video').on('play',function () {
		$(this).attr('controls', '');
		$(this).parent().removeClass('video-poster');
	});
}

function showHidemobileGalleryPopup() {
	$('.pdp__product-gallery--items picture').on('click',function () {
		let gotoIndex = $('.pdp__product-gallery--items picture').index(this);
		$('.pdp__product-gallery--popup').removeClass('hidden').find('.slick-slider').slick('refresh').slick('slickGoTo',gotoIndex);
		if(window.innerWidth < 768) {
			$('body').addClass('cancel-scroll');
		}
	});
	$('.pdp__product-gallery--popup').on('click',()=>{
		$('.pdp__product-gallery--popup').addClass('hidden');
		const $video = $('.pdp__product-gallery--popup video').get(0);
		$video && $video.pause();
		if(window.innerWidth < 768) {
			$('body').removeClass('cancel-scroll');
		}
	});
	$('.pdp__product-gallery--popup .slick-slider').on('click',(e)=>{
		e.stopPropagation();
	});
	$('.pdp__product-gallery--popup .slick-slider').on('beforeChange', function(){
		const $video = $('.pdp__product-gallery--popup video').get(0);
		$video && $video.pause();
	});
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/pdp.js